import { ApolloClient, InMemoryCache, ApolloLink, from } from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { TOKEN_KEY } from "@/contants";

const uploadLink = createUploadLink({
  uri: `${import.meta.env.VITE_API_DOMAIN}/graphql`,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem(TOKEN_KEY);
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : "",
    },
  });
  return forward(operation);
});

export const apolloClient = new ApolloClient({
  link: from([authMiddleware, uploadLink] as ApolloLink[]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          supplyChainBooking: {
            merge: true,
          },
        },
      },
      User: {
        keyFields: (object) => {
          // If user ID is "0" (indicating a temporary/unconfirmed user),
          // use email as part of the cache key to prevent merging
          if (object.id === "0") {
            return `User:${object.id}:${object.email}`;
          }
          // For regular users, use the default ID-based key
          return `User:${object.id}`;
        },
      },
    },
  }),
});
